import {
  DELUXE_SAMPLE_SIZE_GUIDE_LABEL,
  DELUXE_SAMPLE_SIZE_GUIDE_LABEL_SHORT,
  FREE_SAMPLE_SIZE_GUIDE_LABEL,
  FREE_SAMPLE_SIZE_GUIDE_LABEL_SHORT
} from 'modules/variant/constants'
import logUtil from 'utils/log'
import { AIRSHOP_PRODUCT_TO_DELUXE_SAMPLE_SIZE_IN_ML } from 'modules/product/constants'
import removeTrailingPeriodStringUtil from 'utils/string/remove-trailing-period'
import showEllipsisStringUtil from 'utils/string/show-ellipsis/index.js'

/**
 *
 * @param props
 * @param props.isADeluxeSample
 * @param props.isAFreeSample
 * @param props.fullSizeOption
 * @param props.isAPaidSingleUseSample
 * @param {ProductVariantCollection} props.currentVariant
 * @return {*|string}
 */
const getSizeGuideLabelProductSelectUtil = (props) => {
  const {
    isADeluxeSample,
    isAFreeSample,
    fullSizeOption,
    currentVariant,
    isAPaidSingleUseSample,
    short = false,
    isMiniCart = false,
    isMobileScreen = false
  } = props

  logUtil('getSizeGuideLabelProductSelectUtil').debug('[start] props=', props)

  const sizeLabel = currentVariant?.size_label
  if (sizeLabel) {
    const sizeLabelTrailingRemoved = removeTrailingPeriodStringUtil(sizeLabel)
    if (isMiniCart || isMobileScreen) {
      return showEllipsisStringUtil(sizeLabelTrailingRemoved)
    }
    return sizeLabelTrailingRemoved
  }

  if (
    /111SKIN/gi.test(currentVariant?.brand) &&
    /Mask/gi.test(currentVariant?.variant_name)
  ) {
    return
  }

  if (isAFreeSample || isAPaidSingleUseSample) {
    return short
      ? FREE_SAMPLE_SIZE_GUIDE_LABEL_SHORT
      : FREE_SAMPLE_SIZE_GUIDE_LABEL
  }

  const productId = currentVariant?.product_id
  const deluxeSampleSizeInMl = (
    AIRSHOP_PRODUCT_TO_DELUXE_SAMPLE_SIZE_IN_ML[productId]
  )

  if (
    isADeluxeSample &&
    deluxeSampleSizeInMl
  ) {
    return short
      ? `${deluxeSampleSizeInMl} ml`
      : `${deluxeSampleSizeInMl} ml enough for 10+ uses`
  }

  if (isADeluxeSample) {
    return short
      ? DELUXE_SAMPLE_SIZE_GUIDE_LABEL_SHORT
      : DELUXE_SAMPLE_SIZE_GUIDE_LABEL
  }

  if (!fullSizeOption) {
    return
  }

  return removeTrailingPeriodStringUtil(fullSizeOption)
}

export default getSizeGuideLabelProductSelectUtil
